import { DeploymentState } from 'common/CommonConstants';
import { CoreInstanceType } from 'common/core/CoreInstanceConstants';
import { GitConfigUserSchema } from 'common/deployment/GitConfigDocuments';
import type { ProjectDocument } from 'common/project/ProjectDocument';
import { componentWithValuesSchema } from 'common/stack/ComponentWithValuesDocuments';
import { stackConfigSchema } from 'common/stack/StackConfigDocuments';
import { z } from 'zod';

export const clientDeploymentSchema = z
  .object({
    id: z.number().int(),
    coreID: z.number().int().nullable(),
    name: z.string().min(1, 'Name is required'),
    url: z.string(),
    stage: z.enum(['development', 'staging', 'production']),
    gitConfigUser: GitConfigUserSchema,
    stackConfig: stackConfigSchema,
    componentsWithValues: z.array(componentWithValuesSchema),
    repositoryUrl: z.string().min(1).nullable(),
    repositoryRef: z.string().min(1).nullable(),
    deploymentStateID: z.nativeEnum(DeploymentState),
    cloneOfDeploymentID: z.number().int().nullable(),
    cloneOfDeploymentName: z.string().nullable(),
    coreInstanceTypeID: z.nativeEnum(CoreInstanceType),
    allowEnableFromURL: z.boolean(),
    sshUsernames: z.array(
      z.object({
        sshConnectString: z.string(),
        podName: z.string(),
        namespaceName: z.string(),
        containerName: z.string(),
      })
    ),
  })
  .strict();

export type ClientDeploymentDocument = z.infer<typeof clientDeploymentSchema>;

export type ClientDeploymentProjectDocument = Pick<
  ProjectDocument,
  'id' | 'accountID' | 'accountName' | 'accountIdentifier' | 'name' | 'defaultDomain'
>;
